export default "__VITE_ASSET__CFSYGPhc__"